import { Badge } from '@/components/ui/badge'
import { Progress } from '@/components/ui/progress'
import type { ImportBatch } from '@/schemas'
import { format } from 'date-fns'

const STATUS_VARIANTS: Record<
  ImportBatch['status'],
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  uploading: 'secondary',
  mapping: 'secondary',
  importing: 'default',
  completed: 'outline',
  failed: 'destructive',
}

interface ImportBatchRowProps {
  batch: ImportBatch
}

export function ImportBatchRow({ batch }: ImportBatchRowProps) {
  const total = batch.row_count ?? 0
  const done = batch.imported_count + batch.skipped_count + batch.failed_count
  const progress = total > 0 ? Math.round((done / total) * 100) : 0

  return (
    <tr className="border-b last:border-0 hover:bg-muted/30 transition-colors">
      <td className="px-3 py-2.5 text-sm font-medium truncate max-w-[200px]">
        {batch.filename}
      </td>
      <td className="px-3 py-2.5">
        <Badge variant={STATUS_VARIANTS[batch.status]} className="capitalize text-xs">
          {batch.status}
        </Badge>
      </td>
      <td className="px-3 py-2.5 text-sm text-muted-foreground">
        {batch.row_count ?? '—'}
      </td>
      <td className="px-3 py-2.5 text-sm text-green-600">{batch.imported_count}</td>
      <td className="px-3 py-2.5 text-sm text-muted-foreground">{batch.skipped_count}</td>
      <td className="px-3 py-2.5 text-sm text-destructive">{batch.failed_count}</td>
      <td className="px-3 py-2.5 min-w-[100px]">
        {batch.status === 'importing' ? (
          <Progress value={progress} className="h-1.5 w-24" />
        ) : null}
      </td>
      <td className="px-3 py-2.5 text-xs text-muted-foreground">
        {format(new Date(batch.created_at), 'd MMM yyyy HH:mm')}
      </td>
    </tr>
  )
}
